export default {"src":"/_next/static/media/Group-25761-1.b5a74371.svg","height":255,"width":439};